export default "/_next/static/assets/DunbarTall-Ultra_9fb3c7ae7e024986e99281a118431364.woff2";